 import { getID } from "src/libs/utilities";

const shedules_cards = () : any[] => {
    return [
        {
        "id": getID("shedules"),
        "vertival_align": "full",
        "animated": "fadeInUp",
        "animated_delay": "waterfall",
        "type": "shedules_cards",
        "order": [
            "thumbnail",
            "title",
            "description",
            "statistic_line",
            "checkbox",
            "links"
        ],
        "design_type": 1,
        "cards": [
            {
                "id": getID(""),
                "thumbnail": {
                    "data": "https://i.pinimg.com/736x/cd/a5/23/cda523201bf1af222f6f2d1a864d7f25.jpg"
                },
                "order": {
                    "id": getID(""),
                },
                "title": { 
                    "id": getID(""),
                    "data": "Начало всего" 
                },
                "description": {
                    "id": getID(""),
                    "data": "Трансляция пока будет продолжаться, поэтому можно и дальше наблюдать за гнездовьем солнечных орлов. Ведь даже без хозяев на гнезде бывает интересно. Например, в прошлом году благодаря онлайн-камере удалось впервые для национального парка «Сенгилеевские горы» обнаружить редкую в нашей области птичку — хохлатую синицу. В осенне-зимний период частыми гостями на гнезде бывают орланы-белохвосты."
                },
                "time": {
                    "id": getID(""),
                    "start_time": 1759223643,
                    "finish_time": 1759223660,
                    "intent": "success"
                },
                "person": {
                    "id": getID(""),
                    "data": {
                    "user": {
                        "id": "11",
                        "display_name": "Потап Потапыч Левиофанъ",
                        "avatar": "https://i.pinimg.com/736x/8f/3d/dc/8f3ddcf4d9ad1327f77dc802ec712b1d.jpg",
                        "description": "Умная каракатица. Завуч"
                    }
                    }
                },
                "statistic_line": { 
                    "id": getID(""),
                    "data": [45, 12] 
                }
            },
            {
                "id": getID(""),
                "thumbnail": {
                "data": "https://i.pinimg.com/736x/72/d9/ee/72d9ee8bc76cdcc42ef9e1ef5aaa9bcc.jpg"
            },
            "order": {
                "id": getID(""),
            },
            "title": { 
                "id": getID(""),
                "data": "Продолжение всего" 
            },
            "description": {
                "id": getID(""),
                "data": "Молодой человек ушёл от семьи и уехал за духовными исканиями в наш Владимир, где занимается, собственно, духовными исканиями, пьёт, пишет книжку и работает экскурсоводом. К нему приезжает тесть с сыном, который скучает по отцу. У тестя целых два коварных плана: либо вернуть блудного в семью, либо, если не согласится, дискредитировать перед сыном. Но ничего этого не получается. Они заходят в Успенский собор и потом ночуют у Покрова на Нерли, сын впечатлён и обещает вернуться, когда подрастёт."
            },
            "time": { 
                "id": getID(""),
                "start_time": 1759223643, 
                "finish_time": 1759223660 
            },
            "person": {
                "id": getID(""),
                "data": {
                "user": {
                    "id": "11",
                    "display_name": "Бри Ларссон",
                    "avatar": "https://i.pinimg.com/1200x/20/2d/9f/202d9f6b051b6bd4f917e5a3aa6960cd.jpg",
                    "description": "Учитель москваведения. Профессор ксенологии королевсого университета Мбабане."
                }
                }
            },
            "statistic_line": { 
                "id": getID(""),
                "data": [32, 85] 
            }
            },
            {
                "id": getID(""),
                "thumbnail": {
                    "data": "https://i.pinimg.com/1200x/bf/ba/a4/bfbaa4b60e44c523c8b4d7e18fa88ee9.jpg"
                },
                "order": {
                    "id": getID(""),
                },
                "title": { 
                    "id": getID(""),
                    "data": "Окончание всего" 
                },
                "description": {
                    "id": getID(""),
                    "data": "<p>Встречи с чудовищами - редкий для советской фантастики тип историй. Его развитию мешала приставка «научный» в жанровом определении. Однако все равно эти истории время от времени прорывались на страницы журналов. То про растения, потребляющих путешественников, то про гигантских насекомых, нападающих на аэропланы.<p>В 1936 году на страницах «Вокруг света» таких историй случилось - небывалое дело! -сразу две. Некто, укрывшийся под псевдонимом А. Фористер сначала рассказал о гнезде гигантских ос (Дьявол Белой горы), а потом о гигантской стрекозе, пьющей кровь у геологов (Меганейра). Для первой истории иллюстрации сделал Неимоверный Кочергин, а историю про стрекозу-вампира проиллюстрировал Александр Медельский."
                },
                "time": { 
                    "id": getID(""),
                    "start_time": 1759223643, 
                    "finish_time": 1759223660 
                },
                "person": {
                    "id": getID(""),
                    "data": {
                    "user": {
                        "id": "11",
                        "display_name": "Матвей Епифанович Кыщ",
                        "avatar": "https://i.pinimg.com/1200x/7a/2e/81/7a2e8188dafcc2eeb1f3ed10e0804eb4.jpg",
                        "description": "Учитель пения. Контртенор."
                    }
                    }
                },
                "statistic_line": { 
                    "id": getID(""),
                    "data": [90, 43] 
                }
            },
            {
                "id": getID(""),
                "thumbnail": {
                    "id": getID(""),
                    "data": "https://i.pinimg.com/736x/1b/cd/b2/1bcdb28377aced744f45078aee507b87.jpg"
                },
                "order": {
                    "id": getID(""),
                },
                "title": { 
                    "id": getID(""),
                    "data": "Подведение итогов всего" 
                },
                "description": {
                    "id": getID(""),
                    "data": "<p>Суперхитом 1956 года среди журнальных фантастических публикаций стала повесть Эдмонда Гамильтона «Сокровище Громовой Луны». Советской фантастике очень не хватало авантюризма, приключенческих сюжетов с перестрелками, бандитами, поиском сокровищ и прочими атрибутами, составившими в свое время репутацию жанру."
                },
                "time": { 
                    "id": getID(""),
                    "start_time": 1759223643, 
                    "finish_time": 1759223660 
                },
                "person": {
                    "id": getID(""),
                    "data": {
                    "user": {
                        "id": "11",
                        "display_name": "Матвей Епифанович Кыщ",
                        "avatar": "https://i.pinimg.com/1200x/7a/2e/81/7a2e8188dafcc2eeb1f3ed10e0804eb4.jpg",
                        "description": "Учитель пения. Контртенор."
                    }
                    }
                },
                "statistic_line": { 
                    "id": getID(""),
                    "data": [40, 73] 
                }
            }
        ],
        "style": {
            "backgroundColor": "var(--force-plain-secondary-opacity-color)",
            "border": "1px solid var(--force-mini-contast-color)"
        }
        },
        {
            "type": "shedules_cards",
            "columns": 3,
            "id": getID(""),
            "vertival_align": "full",
            "animated": "fadeInUp",
            "animated_delay": "waterfall",
            "order": [
            "thumbnail",
            "order",
            "time",
            "title",
            "description",
            "statistic_line",
            "person",
            "checkbox",
            "links"
            ],
            "design_type": 2,
            "cards": [
            {
                "id": getID("card"),
                "thumbnail": {
                    "id": getID(""),
                    "data--": "https://i.pinimg.com/736x/a4/c2/f0/a4c2f0ad358af4d1fc64651b7bc521b7.jpg",
                    "data": "https://i.pinimg.com/736x/64/56/c8/6456c86783e5585be9c49173957ea69b.jpg"
                },
                "order": {
                    "id": getID(""),
                },
                "title": { 
                    "id": getID(""),
                    "data": "Начало всего" 
                },
                "description": {
                    "id": getID(""),
                    "data": "Трансляция пока будет продолжаться, поэтому можно и дальше наблюдать за гнездовьем солнечных орлов. Ведь даже без хозяев на гнезде бывает интересно. Например, в прошлом году благодаря онлайн-камере удалось впервые для национального парка «Сенгилеевские горы» обнаружить редкую в нашей области птичку — хохлатую синицу. В осенне-зимний период частыми гостями на гнезде бывают орланы-белохвосты."
                },
                "time": { 
                    "id": getID(""),
                    "start_time": 1759223643, 
                    "finish_time": 1759223660 
                },
                "person": {
                    "id": getID(""),
                    "data": {
                        "user": {
                        "id": "10",
                        "display_name": "Потап Потапыч Левиофанъ",
                        "avatar": "https://i.pinimg.com/736x/8f/3d/dc/8f3ddcf4d9ad1327f77dc802ec712b1d.jpg",
                        "description": "Умная каракатица. Завуч"
                        }
                    }
                },
                "statistic_line": { 
                    "id": getID(""),
                    "data": [45, 12] 
                }
            },
            {
                "id": getID("card"),
                "thumbnail": {
                    "id": getID(""),
                    "data--": "https://i.pinimg.com/736x/72/d9/ee/72d9ee8bc76cdcc42ef9e1ef5aaa9bcc.jpg",
                    "data": "https://i.pinimg.com/736x/34/ba/54/34ba5450bd99fcd160fd15f8f157329a.jpg"
                },
                "order": {
                    "id": getID(""),
                },
                "title": { 
                    "id": getID(""),
                    "data": "Продолжение всего" 
                },
                "description": {
                    "id": getID(""),
                    "data": "Молодой человек ушёл от семьи и уехал за духовными исканиями в наш Владимир, где занимается, собственно, духовными исканиями, пьёт, пишет книжку и работает экскурсоводом. К нему приезжает тесть с сыном, который скучает по отцу. У тестя целых два коварных плана: либо вернуть блудного в семью, либо, если не согласится, дискредитировать перед сыном. Но ничего этого не получается. Они заходят в Успенский собор и потом ночуют у Покрова на Нерли, сын впечатлён и обещает вернуться, когда подрастёт."
                },
                "time": {
                    "id": getID(""), 
                    "start_time": 1759223643, 
                    "finish_time": 1759223660 
                },
                "person": {
                    "id": getID(""),
                    "data": {
                        "user": {
                        "id": "11",
                        "display_name": "Бри Ларссон",
                        "avatar": "https://i.pinimg.com/1200x/20/2d/9f/202d9f6b051b6bd4f917e5a3aa6960cd.jpg",
                        "description": "Учитель москваведения. Профессор ксенологии королевсого университета Мбабане."
                        }
                    }
                },
                "statistic_line": {
                    "id": getID(""), 
                    "data": [32, 85] 
                }
            },
            {
                "id": getID("card"),
                "thumbnail": {
                    "id": getID(""),
                    "data--": "https://i.pinimg.com/1200x/bf/ba/a4/bfbaa4b60e44c523c8b4d7e18fa88ee9.jpg",
                    "data": "https://i.pinimg.com/736x/18/49/01/18490141a64d79f09f1b7e8c54c2ae2a.jpg"
                },
                "order": {
                    "id": getID(""),

                },
                "title": { 
                    "id": getID(""),
                    "data": "Окончание всего" 
                },
                "description": {
                    "id": getID(""),
                    "data": "<p>Встречи с чудовищами - редкий для советской фантастики тип историй. Его развитию мешала приставка «научный» в жанровом определении. Однако все равно эти истории время от времени прорывались на страницы журналов. То про растения, потребляющих путешественников, то про гигантских насекомых, нападающих на аэропланы."
                },
                "time": { 
                    "id": getID(""),
                    "start_time": 1759223643, 
                    "finish_time": 1759223660 
                },
                "person": {
                    "id": getID(""),
                    "data": {
                        "user": {
                        "id": "11",
                        "display_name": "Матвей Епифанович Кыщ",
                        "avatar": "https://i.pinimg.com/1200x/7a/2e/81/7a2e8188dafcc2eeb1f3ed10e0804eb4.jpg",
                        "description": "Учитель пения. Контртенор."
                        }
                    }
                },
                "statistic_line": { 
                    "id": getID(""),
                    "data": [90, 43] 
                }
            }
            ],
            "style": {
            "backgroundColor": "var(--force-plain-secondary-opacity-color)",
            "border": "1px solid var(--force-mini-contast-color)"
            }
        },
        {
            "type": "shedules_cards",
            "id": getID("shedules_cards"),
            "vertival_align": "full",
            "order": [
                "thumbnail",
                "order",
                "time",
                "title",
                "description",
                "statistic_line",
                "person",
                "checkbox",
                "links"
            ],
            "animated": "fadeInUp",
            "animated_delay": "waterfall",
            "design_type": 3,
            "cards": [
                {
                    "id": getID("shedule"),
                    "thumbnail": {
                        "id": getID(""),
                        "data--": "https://i.pinimg.com/736x/a4/c2/f0/a4c2f0ad358af4d1fc64651b7bc521b7.jpg",
                        "data": "https://i.pinimg.com/736x/64/56/c8/6456c86783e5585be9c49173957ea69b.jpg"
                    },
                    "order": {
                        "id": getID(""),
                    },
                    "title": { 
                        "id": getID(""),
                        "data": "Начало всего" 
                    },
                    "description": {
                        "id": getID(""),
                        "data": "Трансляция пока будет продолжаться, поэтому можно и дальше наблюдать за гнездовьем солнечных орлов. Ведь даже без хозяев на гнезде бывает интересно. Например, в прошлом году благодаря онлайн-камере удалось впервые для национального парка «Сенгилеевские горы» обнаружить редкую в нашей области птичку — хохлатую синицу. В осенне-зимний период частыми гостями на гнезде бывают орланы-белохвосты."
                    },
                    "time": {
                        "id": getID(""),
                        "start_time": 1759223643,
                        "finish_time": 1759223660,
                        "intent": "success"
                    },
                    "person": {
                        "id": getID(""),
                        "data": {
                        "user": {
                            "id": "11",
                            "display_name": "Потап Потапыч Левиофанъ",
                            "avatar": "https://i.pinimg.com/736x/8f/3d/dc/8f3ddcf4d9ad1327f77dc802ec712b1d.jpg",
                            "description": "Умная каракатица. Завуч"
                        }
                        }
                    },
                    "statistic_line": { 
                        "id": getID(""),
                        "data": [45, 12] 
                    }
                },
                {
                    "id": getID("shedule"),
                    "thumbnail": {
                        "id": getID(""),
                        "data--": "https://i.pinimg.com/736x/72/d9/ee/72d9ee8bc76cdcc42ef9e1ef5aaa9bcc.jpg",
                        "data": "https://i.pinimg.com/736x/34/ba/54/34ba5450bd99fcd160fd15f8f157329a.jpg"
                    },
                    "order": {
                        "id": getID(""),
                    },
                    "title": { 
                        "id": getID(""),
                        "data": "Продолжение всего" 
                    },
                    "description": {
                        "id": getID(""),
                        "data": "Молодой человек ушёл от семьи и уехал за духовными исканиями в наш Владимир, где занимается, собственно, духовными исканиями, пьёт, пишет книжку и работает экскурсоводом. К нему приезжает тесть с сыном, который скучает по отцу. У тестя целых два коварных плана: либо вернуть блудного в семью, либо, если не согласится, дискредитировать перед сыном. Но ничего этого не получается. Они заходят в Успенский собор и потом ночуют у Покрова на Нерли, сын впечатлён и обещает вернуться, когда подрастёт."
                    },
                    "time": { 
                        "id": getID(""),
                        "start_time": 1759223643, 
                        "finish_time": 1759223660 
                    },
                    "person": {
                        "id": getID(""),
                        "data": {
                        "user": {
                            "id": "11",
                            "display_name": "Бри Ларссон",
                            "avatar": "https://i.pinimg.com/1200x/20/2d/9f/202d9f6b051b6bd4f917e5a3aa6960cd.jpg",
                            "description": "Учитель москваведения. Профессор ксенологии королевсого университета Мбабане."
                        }
                        }
                    },
                    "statistic_line": { 
                        "id": getID(""),
                        "data": [32, 85] 
                    }
                },
                {
                    "id": getID("shedule"),
                    "thumbnail": {
                        "id": getID(""),
                        "data--": "https://i.pinimg.com/1200x/bf/ba/a4/bfbaa4b60e44c523c8b4d7e18fa88ee9.jpg",
                        "data": "https://i.pinimg.com/736x/18/49/01/18490141a64d79f09f1b7e8c54c2ae2a.jpg"
                    },
                    "order": {
                        "id": getID(""),
                    },
                    "title": { 
                        "id": getID(""),
                        "data": "Окончание всего" 
                    },
                    "description": {
                        "id": getID(""),
                        "data": "<p>Встречи с чудовищами - редкий для советской фантастики тип историй. Его развитию мешала приставка «научный» в жанровом определении. Однако все равно эти истории время от времени прорывались на страницы журналов. То про растения, потребляющих путешественников, то про гигантских насекомых, нападающих на аэропланы.<p>В 1936 году на страницах «Вокруг света» таких историй случилось - небывалое дело! -сразу две. Некто, укрывшийся под псевдонимом А. Фористер сначала рассказал о гнезде гигантских ос (Дьявол Белой горы), а потом о гигантской стрекозе, пьющей кровь у геологов (Меганейра). Для первой истории иллюстрации сделал Неимоверный Кочергин, а историю про стрекозу-вампира проиллюстрировал Александр Медельский."
                    },
                    "time": { 
                        "id": getID(""),
                        "start_time": 1759223643, 
                        "finish_time": 1759223660 
                    },
                    "person": {
                        "id": getID(""),
                        "data": {
                        "user": {
                            "id": "11",
                            "display_name": "Матвей Епифанович Кыщ",
                            "avatar": "https://i.pinimg.com/1200x/7a/2e/81/7a2e8188dafcc2eeb1f3ed10e0804eb4.jpg",
                            "description": "Учитель пения. Контртенор."
                        }
                        }
                    },
                    "statistic_line": { 
                        "id": getID(""),
                        "data": [90, 43] 
                    }
                }
            ],
            "style": {
                "backgroundColor": "var(--force-plain-secondary-opacity-color)",
                "border": "1px solid var(--force-mini-contast-color)"
            }
        }
    ]
}
export default shedules_cards